import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import FlashSection from './components/FlashSection';
import Collections from './components/Collections';
import Timeline from './components/Timeline';
import IndexPanel from './components/IndexPanel';
import Radar from './components/Radar';
import Faq from './components/Faq';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-900">
      <SiteHeader />
      <main>
        <Hero />
        <FlashSection />
        <Collections />
        <Timeline />
        <IndexPanel />
        <Radar />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}